<template>
  <div class="main-container">
    <!-- header -->
    <header style="border:0px;">
      <div class="clearfix">
        <div style="text-align: right;">
          <img src="../assets/img/login_260730.png" width="140" alt class="imglogin">
        </div>
      </div>
    </header>
    <!-- section -->
    <section>
      <h3>PARK&CHARGE</h3>
      <h3>预约停车充电</h3>
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="10">
            <b-form-input id="input-default" type="number" :state="validationPhone" :placeholder="$t('m.login.phoneLength')" v-model="phoneCode" :formatter="formatterPhone"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1" id="code">
          <b-col sm="10" style="margin-top:10px;">
            <input
                id="input-default1"
                type="text"
                class="idenCode"
                maxlength="4"
                v-model="kaptcha"
            >
            <img :src="codeUrl" class="idenCodeText" style="max-width: 42%;" @click="fetchKaptcha()"/>
          </b-col>
        </b-row>
        <b-row class="my-1" id="code">
          <b-col sm="10" style="margin-top:10px;">
            <b-form-input
                id="input-default2"
                type="number"
                :state="validationCode"
                :placeholder="$t('m.login.code')" :disabled="phoneCode==''"
                class="idenCode"
                v-model="identifyingCode"
                :formatter="formatterCode"
            ></b-form-input>
            <b-button href="#" class="idenCodeText"
                      :disabled="!isNaN(this.seconds) || phoneCode.length!=11 || kaptcha.length != 4">
              <span style="display: block" @click="onUserCode()">
                {{ seconds }}
                <i v-if="!isNaN(this.seconds)">S</i>
              </span>
            </b-button>
          </b-col>
        </b-row>
        <!-- 用户协议 -->
        <b-row class="my-1">
          <b-col sm="10" style="margin-top:10px;">
            <div class="userProtocol">
              <b-form-checkbox v-model="agreeChecked"></b-form-checkbox>
              <div class="tongyi">
                {{ $t("m.confirmOrder.accept") }}
                <router-link to="/userTreaty">
                  <span style="color:#0066B1">{{ $t("m.confirmOrder.selectAgreement") }}</span>
                </router-link>
                <router-link to="/policy">
                  <span style="color:#0066B1">{{ $t("m.confirmOrder.selectpolicy") }}</span>
                </router-link>
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- button -->
        <b-row class="my-1">
          <b-col sm="10" style="margin-top:10px;">
            <b-button href="#" id="submitLogin_login" :disabled="phoneCode.length!=11|| identifyingCode.length!=4 || !agreeChecked">
              <span style="display: block" @click="onUserLogin()">{{ $t('m.login.login') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!-- footer -->
    <footer style="position: absolute;bottom: 10px;left: 0;">
      <!-- <p>本服务由华航提供</p> -->
      <p> {{ $t('m.login.serverTips') }}</p>
      <p>{{ $t('m.login.serverPhone') }}：400-115-0606</p>
    </footer>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { loginByUsersend, loginByUsername, getKaptchaUrl, loginBind } from "../api/login.js";
import config from "@/config/Config.vue";

export default {
  name: "Login",
  data() {
    return {
      phoneCode: "", //手机号
      identifyingCode: "", //验证码
      openId: "", //微信
      seconds: "", //秒
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      timeStamp: '', // 图形验证码标识
      intervalTime: null,
      codeUrl: '',
      kaptcha: '',
      source: "",
      agreeChecked: false, //是否勾选用户协议和隐私政策
    };
  },
  computed: {
    validationPhone() {
      return this.phoneCode.length === 11
    },
    validationCode() {
      return this.identifyingCode.length === 4
    }
  },
  created() {
    this.source = this.getQueryString("source");
    this.seconds = this.$t('m.login.getCode');
	this.fetchKaptcha();
    let c = sessionStorage.getItem("c")
    if(c){
      this.source = "YDWX"
    }
    if (!this.source) {
      this.source = "H5"
    }
  },
  mounted(){
  },
  activated(){
  },
  destroyed() {
    if (this.intervalTime != null) {
      clearInterval(this.intervalTime);
    }
  },
  methods: {
    formatterPhone(value) {
      return value.length > 11 ? (value + '').slice(0,11) : value
    },
    formatterCode(value) {
      return value.length > 4 ? (value + '').slice(0,4) : value
    },
    //获取验证码方法
    onUserCode: function () {
      if (!/^((1[3-9][0-9]))\d{8}$/.test(this.phoneCode)) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t('m.login.errorPhoneformat');
        this.tipType = "error";
        return false;
      } else {
        loginByUsersend({phone: this.phoneCode, kaptcha: this.kaptcha, timeStamp: this.timeStamp}).then(
            response => {
              if (response.data.status == 200) {
                this.tipShow = "1" + Math.random() * 1000;
                this.message = this.$t('m.login.sucessSend');
                this.tipType = "success";
                this.seconds = 59;
                this.intervalTime = setInterval(() => {
                  if (this.seconds > 1) {
                    this.seconds--;
                  } else {
                    this.seconds = this.$t('m.login.getCode');
                  }
                }, 1000);
              } else {
                this.tipShow = "1" + Math.random() * 1000;
                this.message = response.data.message;
                this.tipType = "warning";
                this.fetchKaptcha();
              }
            }
        );
      }
    },
    //用户登录方法
    onUserLogin() {
      if (!/^((1[3-9][0-9]))\d{8}$/.test(this.phoneCode)) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t('m.login.errorPhoneformat');
        this.tipType = "error";
        return false;
      }
      if (!this.agreeChecked) {
        return false;
      }
      this.login()
    },
    login() {
      loginByUsername({
        userPhone: this.phoneCode,
        verificationCode: this.identifyingCode,
        openId: this.openId,
        userSource: this.source,
        inviteUserId: this.getQueryString('inviteUserId')
      }).then(
          response => {
            if (response.data.status == 200) {
              var sult = response.data.result;
              localStorage.setItem("token", sult.token);
              localStorage.setItem("openId", sult.openId);

              if (!sult.openId) {
                this.loadCheckBind();
              }

              this.$router.push("/");
            } else {
              this.tipShow = "1" + Math.random() * 1000;
              this.message = response.data.message;
              this.tipType = "warning";
            }
          });
    },
    //登录检查是否绑定微信
    loadCheckBind: function () {
      let code = this.getQueryString("code")
      loginBind({wxCode: code}).then(
          response => {
            if (response.data.status === 200 || response.data.status === 309) {
              if (response.data.result.token != null) {
                localStorage.setItem("token", response.data.result.token);
              } else {
                this.$router.push("/login");
              }
              if (response.data.result.openId != null) {
                localStorage.setItem("openId", response.data.result.openId);
                this.openId = response.data.result.openId
              }
            } else {
              this.tipShow = "1" + Math.random() * 1000;
              this.message = response.data.message;
              this.tipType = "warning";
            }
          }
      );
    },
    fetchKaptcha() {
      getKaptchaUrl().then(res => {
        const data = res.data;
        if (data.status == 200) {
          this.codeUrl = config.API_URL + data.result.url;
          this.timeStamp = data.result.timeStamp;
        }
      });
    },
    getQueryString(name) {
      var reg = new RegExp('(^|/?)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.href.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
  }
};
</script>
<style scoped>
section {
  margin-top: 55px;
  color: #0066B1;
  width: 100%;
}

section h3 {
  margin: 0px;
}

section .idenCode {
  width: 60%;
  display: inline-block;
  float: left;
}

.main-container div .imglogin {
  /* padding-right: 10px;
  border-right: 2px solid #c8c9ca; */
}

.container-fluid {
  margin-top: 50px;
}

.container-fluid .row {
  margin: 0px;
}

.container-fluid .col-sm-10 {
  margin: 0 20px;
}

.container-fluid .idenCodeText {
  float: right;
  line-height: 31px;
  background-color: #0066B1;
  border: 0;
}

.container-fluid .idenCodeText span i {
  font-size: 13px;
}

#submitLogin {
  width: 81%;
  background-color: #0066B1;
  line-height: 35px;
  font-size: 18px;
  margin-top: 20px;
}
#submitLogin_login {
  width: 100%;
  background-color: #0066B1;
  line-height: 35px;
  font-size: 18px;
}

section .userProtocol {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 14px;
}

section .userProtocol .custom-control {
  margin-right: 4px;
}

section .userProtocol .tongyi {
  line-height: 1.2;
}

.container-fluid .col-sm-10 {
  padding: 0;
}

.container-fluid .col-sm-10 input {
  background-color: #f2fbff;
  border: 1.3px solid #0066B1;
  height: 45px;
}

.container-fluid #code .col-sm-10 input {
  width: 55%;
}

.container-fluid #code .col-sm-10 a {
  width: 42%;
  text-align: center;
}

footer {
  text-align: center;
  width: 100%;
  padding: 0px;
}

footer p {
  margin: 0 auto;
  padding: 0px;
  font-size: 13px;
  color: #0066B1;
}

#input-default1 {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  border: 1.3px solid #0066B1;
  background-color: #f2fbff;
  background-clip: padding-box;
  /* border: 1px solid #ced4da; */
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}

#input-default1:focus {
  color: #495057;
  border-color: #80bdff;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>


